<template>
    <div>
        <div v-if="displayHeader" class="text-center">
            <b-img width="100" v-if="loading" :src="require('../assets/img/icons/satellite.png')"></b-img>
            <b-img width="100" v-else :src="require('../assets/img/icons/twitter.png')"></b-img>

            <h2 class="mt-3" v-tr>Contact Form|Formulaire de contact</h2>
            <p v-if="!completed" class="lead font-weight-normal" v-tr>
                Do you need a quote or more information?|Besoin d'une estimation ou de plus d'informations?
            </p>
        </div>

        <b-form v-if="!completed" @submit.prevent="recaptcha">
            <b-row class="text-left">
                <b-col cols="12" md="6" lg="3">
                    <b-form-group>
                        <label class="required"><span v-tr>Name|Nom</span> <b class="required">*</b></label>
                        <e-input class="no-flow" type="name" autocomplete="given-name" required v-model="request.first_name"></e-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6" lg="5">
                    <b-form-group>
                        <label class="required"><span v-tr>E-mail|Courriel</span> <b class="required">*</b></label>
                        <e-input autocomplete="email" required v-model="request.email" type="email" :state="isEmailValid"></e-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="12" lg="4">
                    <b-form-group>
                        <label><span v-tr>Phone number (optional)|Numéro de téléphone (optionel)</span></label>
                        <e-input type="tel" v-model="request.phone"></e-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-form-group>
                <label class="required"><span v-tr>Your message|Votre message</span> <b class="required">*</b></label>
                <b-textarea @focus="loadRecaptcha" :state="isMessageValid" autocomplete="false" required v-model="request.message" type="text" maxlength="500" style="min-height: 100px;"></b-textarea>
            </b-form-group>
            <div class="text-right">
                <b-btn class="contact-button f-500" style="padding: 7px 30px;" :disabled="loading" variant="primary" @click="recaptcha" v-tr>Submit|Envoyer</b-btn>
            </div>
        </b-form>
        <div class="py-5 text-center" v-else>
            <b-img class="mb-3" width="100" :src="require('../assets/img/icons/thumb-up.png')"></b-img>
            <p v-tr>Thanks for reaching us|Merci de nous avoir contacté</p>
        </div>
    </div>
</template>

<script>
    import EInput from "../../vue-components/components/e-input.vue";
    import Network from '../../vue-components/helpers/Network';
    import {getLanguage} from "../../vue-components/helpers/i18n";
    import Validation from "../../vue-components/helpers/Validation.js";

    export default {
        name: `contact-form`,
        components: {EInput},
        props: {
            displayHeader: {type: Boolean, default: false}
        },
        data() {
            return {
                loading: false,
                completed: false,
                request: {
                    first_name: ``,
                    last_name: ``,
                    email: ``,
                    phone: ``,
                    company_name: ``,
                    country: null,
                    features: null,
                    equipment: {},
                    no_equipment: true,
                    router_brands: null,
                    message: ``
                }
            }
        },
        computed: {
            isMessageValid() {
                return Validation.testText(this.request.message);
            },
            isEmailValid() {
                return Validation.testEmail(this.request.email);
            }
        },
        activated() {
            window.scrollTo(0, 0);
        },
        methods: {
            loadRecaptcha() {
                // Avoid loading at launch to reduce network load
                if (!window.recaptcha) {
                    let script = document.createElement(`script`);
                    script.setAttribute(`src`, `https://www.google.com/recaptcha/api.js?render=6LfkaEAaAAAAAKIFZewduAMWbMReDfKXJ6j4TjBp`);
                    document.body.appendChild(script);
                }
            },
            recaptcha() {
                grecaptcha.ready(() => {
                    grecaptcha.execute(`6LfkaEAaAAAAAKIFZewduAMWbMReDfKXJ6j4TjBp`, {action: `submit`}).then(token => {
                        this.submit(token);
                    });
                });
            },
            submit(token) {
                if (isStringEmpty(this.request.first_name) ||
                    isStringEmpty(this.request.email) ||
                    isStringEmpty(this.request.message)) {
                    this.$swal(this.tr(`Missing fields|Champs manquants`), this.tr(`One or more required fields are missing.|Un ou plusieurs champs sont manquants.`), `info`);
                    return false;
                }
                if (!Validation.testText(this.request.message)) {
                    this.$swal(this.tr(`Invalid message|Message incorrect`), this.tr(`Your message contains invalid characters|Votre message contient des caractères non valides'`), `info`);
                    return false;
                }
                if (this.request.phone && !Validation.testPhoneNumber(this.request.phone, false)) {
                    this.$swal(this.tr(`Phone number invalid|Numéro de téléphone non valide`), this.tr(`Please make sure that you entered a valid phone number.|Merci d'entrer un numéro de téléphone valide.'`), `info`);
                    return false;
                }
                let data = {
                    token: token,
                    source: `Eye-In Media`,
                    first_name: this.request.first_name,
                    last_name: this.request.last_name,
                    email: this.request.email,
                    phone: this.request.phone,
                    company_name: this.request.company_name,
                    country: this.request.country,
                    message: this.request.message,
                    language: getLanguage(),
                    url: window.location.href
                };
                let cookies = window.getCookies();
                for (let key in cookies) {
                    if (key.startsWith(`utm_`)) {
                        data[key] = cookies[key];
                    }
                }
                this.loading = true;
                Network.post(`/website/form/new-contact`, data)
                    .then(() => {
                        this.loading = false;
                        this.completed = true;
                        this.$swal(this.tr(`Thanks|Merci`), this.tr(`Thanks, an agent will contact you soon. You can also call us at +1 (514) 395-9327.|Merci, un agent va vous contacter sous peu. Vous pouvez également nous appeler au +1 (514) 395-9327.`), `success`);
                    })
                    .catch(resp => {
                        console.log(resp);
                        this.loading = false;
                        this.$swal(this.tr(`Error sending message, please try again later|Erreur pendant l'envoi du message, merci de réessayer plus tard`));
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    b.required {
        color: #c65d51;
        margin-left: 5px;
    }

    .checkbox-devices {
        .btn-group-toggle {
            width: 135px;
            height: 145px;
            margin-bottom: 5px;

            & + .btn-group-toggle {
              margin-left: 10px;
            }

            img {
                width: 80px;
                height: 80px;
                object-fit: contain;
                border-radius: 8px;
                margin: 0 0 6px 10px;
            }

            ::v-deep .btn {
                padding: 0;
                position: relative;
                text-align: left;
                background: transparent;
                width: 100%;
                border-radius: 8px;
                outline: none !important;

                ::v-deep div {
                    font-size: 10pt;
                }

                &.active {
                    //background-image: linear-gradient(165deg, #00adc6, #47D6C1);
                    color: white;
                }
                &:not(.active) {
                    color: rgba(255, 255, 255, 0.7);
                }

                &:before,
                &:after {
                    content: "";
                    position: absolute;
                    bottom: 2px;
                    right: 4px;
                    width: 16px;
                    height: 16px;
                    display: inline-block;
                    border: 1px solid #c3c3c3;
                    border-radius: 3px;
                    -webkit-transition: 250ms;
                    transition: 250ms;
                }

                &.active:before {
                    bottom: 7px;
                    right: 16px;
                    width: 15px;
                    height: 6px;
                    border-radius: 6px;
                    border-color: transparent;
                    background-color: #47D6C1;
                    -webkit-transform: rotate(44deg);
                    transform: rotate(44deg);
                }

                &.active:after {
                    bottom: 9px;
                    right: 0px;
                    width: 25px;
                    height: 6px;
                    border-radius: 6px;
                    border-color: transparent;
                    background-color: #47D6C1;
                    -webkit-transform: rotate(-44deg);
                    transform: rotate(-44deg);
                }
            }
        }
    }

    @media (max-width: 578px) {
        .contact-button {
            height: initial !important;
            width: 100%;
        }
    }
</style>
